module.exports = __webpack_public_path__ + "static/media/PushtimargImage27.c6a7cbf8.jpg";